<!-- @format -->

<p class="hmf-pt-xs">
	<pdp-attributes-components-base-attribute-label
		[errorMessage]="(selectErrors$ | async)?.[attributeGroupName()]"
		[errorMessageDisplayable]="!index() || index() === 1"
		[attributeGroupName]="attributeGroupName()"
		[selectedAttributeValue]="selectedAttribute()?.value"
		[selectedAttributeValueDisplayable]="
			!index() || selectedBucketIndex() === index() - 1
		"></pdp-attributes-components-base-attribute-label>
</p>
